import * as Sentry from '@sentry/react';
import { FormSelectField } from '../../../../design-system/form-select-field/form-select-field';
import { Select } from '../../../../design-system/select/select';
import { BeneficiaryView } from '../../../../types/entity-types';
import { BeneficiaryCard } from '../../components/beneficiary-card';
import { getAccountDetails } from '../../utils/get-account-details';
import { isSupportedCurrency } from '../../utils/is-supported-currency';
import { isVopPayeeCheck } from '../../utils/is-vop-payee-check';

type BeneficiarySelectFieldProps = {
  beneficiaries: BeneficiaryView[];
  badge?: string;
};

export const BeneficiarySelectField = ({ beneficiaries, badge }: BeneficiarySelectFieldProps) => {
  return (
    <FormSelectField
      label="Beneficiary"
      inputName="beneficiaryId"
      placeholder="Select a beneficiary"
      badge={badge}
      hideLabel
      triggerClassName="py-4"
      isTriggerFullWidth
    >
      {beneficiaries.map((beneficiary) => {
        const { type, accountNumber, sortCode, iban, currency } = beneficiary.destination;

        const beneficiaryAccountDetails = getAccountDetails({
          type,
          accountNumber,
          sortCode,
          iban,
        });

        if (!isSupportedCurrency(currency)) {
          Sentry.captureMessage('Unsupported currency', {
            extra: {
              beneficiaryId: beneficiary.id,
              beneficiaryDestination: beneficiary.destination,
              currency,
              message:
                'Unsupported beneficiary currency when attempting to render beneficiary card in BeneficiarySelectField',
            },
          });

          return null;
        }

        return (
          <Select.Item key={beneficiary.id} value={beneficiary.id} className="pr-12">
            <BeneficiaryCard
              name={beneficiary.name}
              currency={currency}
              accountDetails={beneficiaryAccountDetails}
              latestPayeeCheck={
                isVopPayeeCheck(beneficiary.latestPayeeCheck) ? beneficiary.latestPayeeCheck.code : undefined
              }
              isSelectOption
            />
          </Select.Item>
        );
      })}
    </FormSelectField>
  );
};
